import calculateField from '../formBuilder/utility/calculateFields';

export const getResult = (field, data) => {
  try {
    return calculateField(field, data, 'object');
  } catch (error) {
    console.error(error);
    return { value: 2, message: 'Error' };
  }
};
